import { AxiosResponse } from 'axios';
import AxiosInstanceYalo from './AxiosInstanceYalo';

export interface IGeneralInfo {
  id: string;
  name: string;
}

export enum STATUS {
  SENT = 'SENT',
  CHAT_CLOSED = 'CHAT_CLOSED',
  REPLIED = 'REPLIED',
}

export interface INotification {
  id: string;
  template: IGeneralInfo;
  contact: IGeneralInfo;
  agent: IGeneralInfo;
  team_id: string;
  created_at: string;
  user_replied_at: string;
  chat_closed_at: string;
  status: `${STATUS}`;
}

export interface IGetStartedByYouChats {
  notifications: INotification[] | null;
  count: number;
  offset: number;
  total: number;
}

export const getStartedByYouChats = async (
  teamsId?: string[],
  agentId?: string
): Promise<AxiosResponse<IGetStartedByYouChats>> => {
  const params = {
    teamsIds: teamsId?.length ? teamsId.join(',') : undefined,
    agentId,
  };

  return AxiosInstanceYalo.get('v2/notification', {
    params,
  });
};
